<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <b-input-group>
                    <b-form-input
                        type="text"
                        placeholder="Busca por marca"
                        v-model="search"
                        :formatter="formatter"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-input-group-text>
                            <b-icon icon="search" />
                        </b-input-group-text>
                    </b-input-group-append>
                </b-input-group>
                <div class="mt-4 mb-2">
                    <div v-if="loading" style="text-align: center;">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <b-list-group style="max-height: 300px; overflow-y: scroll; text-transform: uppercase;">
                        <b-list-group-item
                        v-for="item in filteredMarcas"
                        :key="item._id"
                        @click="setMarca(item)">{{item.name}}</b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {API_MARCAS, HEADERS} from 'providers/ApiCredentials';
import { mapFields } from "vuex-map-fields";
export default {
    data() {
        return {
            loading: true,
            search: ""
        }
    },
    computed: {
        ...mapFields("vender", [
            'asistente_step',
            'titulo_span',
            'selection_data.marca_name',
            'selection_data.marca_id',
            'form_data.marcas'
        ]),
        filteredMarcas: function() {
            return this.marcas.filter((marca) => {
                return marca.name.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    created () {
        this.titulo_span = 'Seleccione la marca...'
        this.loading = false;
    },
    methods: {
        get_marcas() {
            axios.get(API_MARCAS, HEADERS).then(response => {
                var parsingMarcas = _.orderBy(
                    response.data.marcas,
                    ["name"],
                    ["asc"]
                );
                this.marcas = parsingMarcas;
                this.loading = false;
            });
        },
        setMarca(marca) {
            this.marca_name = marca.name;
            this.marca_id = marca._id;
            this.asistente_step = 'modelo';
            this.titulo_span = 'Seleccione modelo...';
            window.history.replaceState(null, null, '?step=2');
        },
        formatter(value) {
            return value.toUpperCase()
        }
    },
};
</script>

<style lang="scss"></style>
